const API_RESOURCES = {
  WAREHOUSES: "warehouses",
  OPEN_SPACES: "open-spaces",
  PALLETS: "pallets",
  ROLLING_CARTS: "rollingcarts",
  GET_COUNTERS: "getCounters",
  CONTAINERS: "containers",
  CONTAINER_TYPES: "containerTypes",
  CATEGORIES: "categories",
  ITEM_CONDITIONS: "itemconditions",
  ITEM_STATUSES: "itemstatuses",
  ITEMS: "items",
  FILES: "files",
  S3_PUT: 'files/put-signed-url',
  S3_GET: 'files/get-signed-url',
  COMMENTS: "comments",
  ROWS: "rows",
  RACKS: "racks",
  LEVELS: "shelves",
  CONTAINER_LOCATION_SHELF: "location/shelf",
  CONTAINER_LOCATION_OS: "location/openSpace",
  CONTAINER_LOCATION: "location/container",
  WAREHOUSE_LOCATION: "locations",
  LOGIN: 'login',
  AUTH_REFRESH: 'auth/refresh',
  USERS: 'users',
  ROLES: 'roles',
  CLIENTS: 'clients',
  USER_CLIENT_ROLES: 'user-client-roles',
  USER_CLIENT_ROLES_ME: 'user-client-roles/by-user/me',
  ITEM_HISTORY: "historic-movements",
  GET_ROLLING_CART_COUNTER: "containers/rolling-cart/next-letter",
  GET_USER_DATA_BY_GOOGLE: "https://www.googleapis.com/oauth2/v3/userinfo",
  ITEMS_EXPORT_INITIATE: "items/export/initiate",
  ITEMS_EXPORT_STATUS: "items/export/status",
  ITEMS_EXPORT_DOWNLOAD: "items/export/download",
};

export default API_RESOURCES;
